import { List } from "antd";
import DocListItem from "./DocListItem";
import { useAppContext } from "../../hooks/useAppContext";

export default function DocListPage({ docs, title, pagination }) {
    const { filterParams, setFilterParams } = useAppContext()
    const {page, limit} = filterParams
    
    return (

        <List
            grid={{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 6 }}
            title={title}
            dataSource={docs}
            renderItem={(item) => <List.Item><DocListItem doc={item} /></List.Item>}
            pagination={pagination ? {
                defaultPageSize: limit,
                total: docs[0]?.full_count,
                showSizeChanger: true,
                showTotal: t => `სულ ${t}`,
                pageSizeOptions: [12,24, 48, 72, 96, 120],
                current: page,
                onChange: (page, limit) => setFilterParams({ ...filterParams, page, limit })
            } : false}
            style={{ boxShadow: '1px 2px 9px gray', borderRadius: 13, padding: 15, height: '100%', backgroundColor: 'white' }}
        />
    )
}